const ContentKey = 'content';
const MaxShownParagraphsKey = 'maxShownParagraphs';
export function makeViewOfDisplayProperties(displayField) {
  if (displayField.richContentOptions) {
    var _displayField$richCon, _displayField$richCon2;
    return {
      [ContentKey]: (_displayField$richCon = displayField.richContentOptions) == null ? void 0 : _displayField$richCon.richContent,
      [MaxShownParagraphsKey]: (_displayField$richCon2 = displayField.richContentOptions) == null ? void 0 : _displayField$richCon2.maxShownParagraphs
    };
  }
  const pageNavigation = displayField.pageNavigationOptions;
  if (pageNavigation) {
    return {
      ...(pageNavigation.submitText ? {
        submitText: pageNavigation.submitText
      } : {}),
      ...(pageNavigation.nextPageText ? {
        nextText: pageNavigation.nextPageText
      } : {}),
      ...(pageNavigation.previousPageText ? {
        previousText: pageNavigation.previousPageText
      } : {})
    };
  }
  return {};
}
//# sourceMappingURL=make-view-of-display-properties.js.map